module.exports = __webpack_public_path__ + "img/thumbnail_BlackWhiteRuffedLemur_m_normal.f9eab171.png";